import React, { useState, Suspense } from 'react';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import ClientForm from 'features/parties/components/clients/ClientForm';
import ClientsList from 'features/parties/components/clients/ClientsList';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';




const Clients = () => {
  const { currentColor } = useStateContext();
  const { openModal } = useLayout();

  const handleAddClient = () => {
    openModal({
      component: <ClientForm />,
      title: 'Добавить клиент',
    });
  };
  return (
    <>
      <Suspense fallback={<Loading/>}>

      <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
        <div className='flex items-center relative'>
          <Tooltip trigger='click' className='mr-2'>
            <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
              <Info size={20} />
            </button>
          </Tooltip>
          <h1 className='text-2xl font-bold'>Клиенты</h1>
          
        </div>
        <div className='flex items-center'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleAddClient()}>
            + Клиент
          </button>
        </div>
      </div>
        
        <ClientsList/>
      </Suspense>
    </>
  );
};

export default Clients;
